import React, { createContext, useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiBell, FiX } from 'react-icons/fi';
import notificationSound from '../sound/notification.mp3';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [showReportNotification, setShowReportNotification] = useState(false);

  const playNotificationSound = () => {
    try {
      const audio = new Audio(notificationSound);
      audio.play().catch(e => console.log('Could not play sound:', e));
    } catch (error) {
      console.log('Sound file not found:', error);
    }
  };

  const checkReportTime = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    
    if (hours === 18 && minutes === 30) {
      const lastShown = localStorage.getItem('lastReportNotification');
      const today = now.toDateString();
      
      if (lastShown !== today) {
        setShowReportNotification(true);
        playNotificationSound();
        localStorage.setItem('lastReportNotification', today);
      }
    }
  };

  const testNotification = () => {
    localStorage.removeItem('lastReportNotification');
    setShowReportNotification(true);
    playNotificationSound();
  };

  useEffect(() => {
    // Check for employee role
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.role !== 'employee') return;

    checkReportTime();
    const interval = setInterval(checkReportTime, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <NotificationContext.Provider value={{ testNotification }}>
      {children}
      
      {/* Global Notification */}
      {showReportNotification && (
        <div className="fixed top-4 right-4 bg-blue-500 text-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
          <div className="flex items-start justify-between">
            <div className="flex items-center">
              <FiBell className="mr-2 mt-1" size={20} />
              <div>
                <h3 className="font-semibold">Daily Report Reminder</h3>
                <p className="text-sm mt-1">Time to submit your daily work report. Please update your task progress and log your activities.</p>
              </div>
            </div>
            <button
              onClick={() => setShowReportNotification(false)}
              className="ml-2 text-white hover:text-gray-200"
            >
              <FiX size={18} />
            </button>
          </div>
          <div className="mt-3 flex gap-2">
            <Link
              to="/employee/timesheet"
              className="px-3 py-1 bg-white text-blue-500 rounded text-sm hover:bg-gray-100"
              onClick={() => setShowReportNotification(false)}
            >
              Log Time
            </Link>
            <Link
              to="/employee/tasks"
              className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
              onClick={() => setShowReportNotification(false)}
            >
              Update Tasks
            </Link>
          </div>
        </div>
      )}
    </NotificationContext.Provider>
  );
};